import React from 'react';
import HighlightInput from './highlight-input';
import * as styles from './option.style';
import OptionIcon from './option-icon';
import { Option } from '../types';

export interface OptionTypeProps {
  option: Option;
  inputValue: string;
}

const createOptionType =
  (icons: boolean, useTypeaheadV5 = false) =>
  ({ option, inputValue }: OptionTypeProps): JSX.Element | string => {
    const showIcon = icons && !(useTypeaheadV5 && option.isRecentSearch);

    return (
      <div css={styles.optionContent}>
        {showIcon && (
          <div css={useTypeaheadV5 ? styles.iconV5 : styles.icon}>
            <OptionIcon option={option} useTypeaheadV5={useTypeaheadV5} />
          </div>
        )}
        <div css={styles.option}>
          <div css={styles.name}>
            <HighlightInput
              optionText={option.label}
              highlightText={inputValue}
            />
          </div>
          <div css={styles.optionCategory}>{option.category}</div>
        </div>
      </div>
    );
  };

export default createOptionType;
